import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';

const HomePage = lazy(() => import('../pages/home/page'));
const ServicesPage = lazy(() => import('../pages/services/page'));
const PortfolioPage = lazy(() => import('../pages/portfolio/page'));
const NotFoundPage = lazy(() => import('../pages/NotFound'));
const SoundServicePage = lazy(() => import('../pages/services/sound/page'));
const LightingServicePage = lazy(() => import('../pages/services/lighting/page'));
const LEDServicePage = lazy(() => import('../pages/services/led/page'));
const BroadcastServicePage = lazy(() => import('../pages/services/broadcast/page'));
const TentServicePage = lazy(() => import('../pages/services/tent/page'));
const PlanningServicePage = lazy(() => import('../pages/services/planning/page'));
const EtcServicePage = lazy(() => import('../pages/services/etc/page'));
const SportsServicePage = lazy(() => import('../pages/services/sports/page'));
const PhotoboothServicePage = lazy(() => import('../pages/services/photobooth/page'));
const StageServicePage = lazy(() => import('../pages/services/stage/page'));
const SoundSalesPage = lazy(() => import('../pages/sales/sound/page'));
const ProductDetailPage = lazy(() => import('../pages/sales/sound/[slug]/page'));
const L65ProductDetailPage = lazy(() => import('../pages/sales/sound/l65-l65s/page'));
const L83ProductDetailPage = lazy(() => import('../pages/sales/sound/l83-l83s/page'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />,
  },
  {
    path: '/services',
    element: <ServicesPage />,
  },
  {
    path: '/services/planning',
    element: <PlanningServicePage />,
  },
  {
    path: '/services/sound',
    element: <SoundServicePage />,
  },
  {
    path: '/services/lighting',
    element: <LightingServicePage />,
  },
  {
    path: '/services/led',
    element: <LEDServicePage />,
  },
  {
    path: '/services/tent',
    element: <TentServicePage />,
  },
  {
    path: '/services/broadcast',
    element: <BroadcastServicePage />,
  },
  {
    path: '/services/sports',
    element: <SportsServicePage />,
  },
  {
    path: '/services/stage',
    element: <StageServicePage />,
  },
  {
    path: '/services/photobooth',
    element: <PhotoboothServicePage />,
  },
  {
    path: '/services/etc',
    element: <EtcServicePage />,
  },
  {
    path: '/portfolio',
    element: <PortfolioPage />,
  },
  {
    path: '/sales/sound',
    element: <SoundSalesPage />,
  },
  {
    path: '/sales/sound/l65-l65s',
    element: <L65ProductDetailPage />,
  },
  {
    path: '/sales/sound/l83-l83s',
    element: <L83ProductDetailPage />,
  },
  {
    path: '/sales/sound/:slug',
    element: <ProductDetailPage />,
  },
  {
    path: '*',
    element: <NotFoundPage />,
  },
];

export default routes;
